import React from 'react';
import type { Feature as FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import Feature from '../Feature';
import { Column } from '../styled.ts';

const renderFeature = (feature: FeatureType, index: number) => (
  <Feature key={`${feature.icon}${feature.featureType}${index}`} testId={feature.className} {...feature} />
);

const FeaturesIterator = ({
  features,
  useColumnLayout = false,
}: {
  features: FeatureType[];
  useColumnLayout?: boolean;
}) => {
  if (useColumnLayout) {
    const left = features.filter((f) => f.gridSide !== 'right');
    const right = features.filter((f) => f.gridSide === 'right');

    return (
      <>
        <Column>{left.map(renderFeature)}</Column>
        {right.length > 0 && <Column>{right.map(renderFeature)}</Column>}
      </>
    );
  }

  return <>{features.map(renderFeature)}</>;
};

export default FeaturesIterator;
